import {
    IconDashboard,
    IconUsers,
    IconNews,
    IconDeviceDesktopAnalytics,
    IconBooks,
    IconSettings,
    IconChartAreaLine
} from '@tabler/icons-react';

import { RBAC_ACTIONS, RBAC_RESOURCES, buildRbacResource } from 'utils/rbac';

const icons = { IconDashboard, IconUsers, IconNews, IconDeviceDesktopAnalytics, IconBooks, IconSettings, IconChartAreaLine };

const dashboard = {
    id: 'dashboard',
    title: 'Dashboard',
    icon: icons.IconDashboard,
    type: 'group',
    breadcrumbs: false,
    url: '/dashboard',
    permissions: {
        resource: buildRbacResource(RBAC_RESOURCES.DASHBOARD),
        action: RBAC_ACTIONS.SHOW
    },
    tags: ['dashboard', 'home', 'overview', 'summary', 'insights', 'main page']
};

const candidates = {
    id: 'candidates',
    title: 'Candidates',
    icon: icons.IconUsers,
    type: 'group',
    breadcrumbs: false,
    url: '/candidates',
    permissions: {
        resource: buildRbacResource(RBAC_RESOURCES.CANDIDATES),
        action: RBAC_ACTIONS.SHOW
    },
    tags: ['candidates', 'prospects', 'applicants', 'job seekers']
};

const assessment = {
    id: 'assessments',
    title: 'Assessments',
    icon: icons.IconNews,
    type: 'group',
    breadcrumbs: false,
    url: '/assessments',
    permissions: {
        resource: buildRbacResource(RBAC_RESOURCES.ASSESSMENTS),
        action: RBAC_ACTIONS.SHOW
    },
    tags: ['assessment', 'tests', 'evaluations', 'quizzes']
};

const courses = {
    id: 'courses',
    title: 'Courses',
    icon: icons.IconDeviceDesktopAnalytics,
    type: 'group',
    breadcrumbs: false,
    url: '/courses',
    permissions: {
        resource: buildRbacResource(RBAC_RESOURCES.COURSES),
        action: RBAC_ACTIONS.SHOW
    },
    tags: ['courses', 'training', 'education', 'learning']
};

const analytics = {
    id: 'analytics',
    title: 'Analytics',
    icon: icons.IconChartAreaLine,
    type: 'group',
    breadcrumbs: false,
    url: '/analytics',
    permissions: {
        resource: buildRbacResource(RBAC_RESOURCES.REPORTS),
        action: RBAC_ACTIONS.SHOW
    },
    tags: ['reports', 'analytics', 'statistics', 'data']
};

const settings = {
    id: 'settings',
    title: 'Settings',
    icon: icons.IconSettings,
    type: 'group',
    breadcrumbs: false,
    url: '/settings',
    permissions: {
        resource: buildRbacResource(RBAC_RESOURCES.SETTINGS),
        action: RBAC_ACTIONS.SHOW
    },
    tags: ['settings', 'configuration', 'preferences', 'admin']
};

const menus = [dashboard, candidates, assessment, courses, analytics, settings];

export default menus;
